import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const DebugToolsRoutes = defineRoute({
    database: {
        route: {
            path: "/debug/database",
            component: () => loadView(import("./DebugDatabase.vue")),
        },
        debug: true,
    },
    daemon: {
        route: {
            path: "/debug/daemon",
            component: () => loadView(import("./DebugDaemon.vue")),
        },
        debug: true,
    },
    notify: {
        route: {
            path: "/debug/notify",
            component: () => loadView(import("./DebugNotify.vue")),
        },
        debug: true,
    },
    whatsApp: {
        route: {
            path: "/debug/whatsapp",
            component: () => loadView(import("./DebugWhatsApp.vue")),
        },
        debug: true,
    },
    widgets: {
        route: {
            path: "/debug/widgets",
            component: () => loadView(import("./DebugWidgets.vue")),
        },
        debug: true,
    },
});
